import { useState, createRef } from "react";
import { DEFAULT_DATA_TABLE_LIMIT, PAGE_Limit } from "../../../../utils/config";
import commonStyles from "../../../features/DataTable.module.scss";
import styles from "./CourseApplicantDataTable.module.scss";
import { AUTH_SHIBUYA } from "../../../../utils/config";
import TextField from "../../../ui/TextField";

const CourseApplicantDataTable = ({
  lotteryStatus,
  attendanceStatus,
  attendance,
  tableData,
  register,
  setValue,
  errors,
  authority,
  headerCkRef,
  recordCkRefs,
  recordLsRefs,
  recordAsRefs,
  recordAuRefs,
  recordUaRefs,
  recordAdRefs,
  resetUpdateData,
  currentPage,
  setCurrentPage,
}) => {
  // ソート項目
  const [sortBy, setSortBy] = useState(null);
  // 昇順フラグ
  const [sortAscending, setSortAscending] = useState(true);
  // 1ページの件数
  const [limit, setLimit] = useState(DEFAULT_DATA_TABLE_LIMIT);

  // 見出しリンククリック
  const handleTableHeaderClick = (clickedField) => {
    // テーブルデータの変更情報リセット
    resetUpdateData();
    if (clickedField === sortBy)
      setSortAscending((sortAscending) => !sortAscending);
    setSortBy(clickedField);
  };

  // ページクリック
  const handlePageClick = (page) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    // テーブルデータの変更情報リセット
    resetUpdateData();
    setCurrentPage(page);
  };

  // 表示件数変更
  const handleLimitChange = (limit) => {
    // テーブルデータの変更情報リセット
    resetUpdateData();
    setLimit(limit);
    setCurrentPage(1);
  };

  // ソート
  let sortedData = tableData;
  if (sortBy == "name_link") {
    // リンクデータ用ソート処理
    sortedData = tableData.slice().sort((a, b) => {
      const a_sort = a[sortBy].props.children;
      const b_sort = b[sortBy].props.children;
      const sort = a_sort.localeCompare(b_sort);
      return sortAscending ? sort : -sort;
    });
  } else if (sortBy === "acquisition_unit") {
    // 単位数ソート処理(値でソート)
    sortedData = tableData.slice().sort((a, b) => {
      const sort = a[sortBy] - b[sortBy];
      return sortAscending ? sort : -sort;
    });
  } else if (sortBy) {
    // 通常ソート処理
    sortedData = tableData.slice().sort((a, b) => {
      const a_sort = String(a[sortBy]);
      const b_sort = String(b[sortBy]);
      const sort = a_sort.localeCompare(b_sort);
      return sortAscending ? sort : -sort;
    });
  }

  const maxPageNum = Math.ceil(sortedData.length / Number(limit));
  // 表示開始件数
  const offset = (currentPage - 1) * limit;
  sortedData = sortedData.slice(offset, offset + Number(limit));

  // 表示件数form/to
  const from = offset + 1;
  const to = offset + sortedData.length;

  // 表示データ件数分のuseRef作成,hiddenフィールドのuseRef作成/データ格納
  sortedData.forEach((_, index) => {
    // チェックボックス
    recordCkRefs.current[index] = createRef();
    // 当選状況
    recordLsRefs.current[index] = createRef();
    // 未受講・受講中・受講済み
    recordAsRefs.current[index] = createRef();
    // 取得単位数
    recordAuRefs.current[index] = createRef();
    // 出席情報更新フラグ値
    recordUaRefs.current[index] = createRef();
    // 出席情報
    recordAdRefs.current[index] = Array();
    {
      Array.from({ length: 15 }).map(
        (_, i) => (recordAdRefs.current[index][i] = createRef())
      );
    }
  });

  // ヘッダーチェックボックスイベント
  const onChangeCk = () => {
    const checked = headerCkRef.current.checked;
    // 全行のチェックボックスを操作
    recordCkRefs.current.map(
      (ref, index) => (
        (ref.current.checked = checked),
        setValue("is_update_attendance_" + index, "1")
      )
    );
  };

  // レコードごとの入力/選択フィールドイベント
  const onChangeRecordField = (index, element, is_attendance = false) => {
    // 対象行のチェックボックスをチェック
    recordCkRefs.current[index].current.checked = true;
    // 見た目はチェック状態だがそのままだとValueがPOSTされないのでsetValue実行
    setValue("is_update_" + index, "1");
    // 背景色変更
    if (!element.className.includes(styles.is_change)) {
      element.className = element.className + " " + styles.is_change;
    }
    // 出席情報の場合
    if (is_attendance) {
      // 出席情報更新フラグ値設定
      setValue("is_update_attendance_" + index, "1");
    }
  };

  // ページネーション
  const Pagination = () => {
    const PageChildNode = (page, label) => {
      return (
        <li
          onClick={() => handlePageClick(page)}
          className={`page-item ${currentPage === label ? "active" : ""} ${
            commonStyles.datatable__pagination__item
          }`}
        >
          <div class="page-link"> {label} </div>
        </li>
      );
    };
    if (maxPageNum === 0) {
      //検索結果0件
      return <></>;
    }
    const disp_range = 3;

    const child = [];
    if (currentPage > disp_range + 1) {
      child.push(PageChildNode(1, 1));
      child.push(PageChildNode(currentPage - 1, "<"));
    }
    for (let i = currentPage - disp_range; i <= currentPage + disp_range; i++) {
      if (i > 0 && i <= maxPageNum) {
        child.push(PageChildNode(i, i));
      }
    }
    if (currentPage < maxPageNum - disp_range) {
      child.push(PageChildNode(currentPage + 1, ">"));
      child.push(PageChildNode(maxPageNum, maxPageNum));
    }

    return (
      <nav className={commonStyles.datatable__pagination}>
        <ul className={commonStyles.datatable__pagination}>{child}</ul>
      </nav>
    );
  };

  /*ページング件数表示 */
  const RecordNum = () => {
    if (tableData.length > 0) {
      return (
        <span
          className={commonStyles.datatable__recordnum}
        >{`${from} - ${to}件 / ${tableData.length}件`}</span>
      );
    } else {
      return <span className={commonStyles.datatable__recordnum}>{`0件`}</span>;
    }
  };

  // レコードごとのチェックボックス
  const returnCkField = (index) => {
    const { ref, ...rest } = register("is_update_" + index);
    return (
      <input
        id={"is_update_" + index}
        type="checkbox"
        value="1"
        ref={(e) => {
          recordCkRefs.current[index].current = e;
          ref(e);
        }}
        {...rest}
      />
    );
  };

  // 当選状況
  const returnLsField = (index, value) => {
    const { ref, ...rest } = register("lottery_status_" + index);

    return (
      <select
        ref={(e) => {
          recordLsRefs.current[index].current = e;
          ref(e);
        }}
        {...rest}
        onChange={(e) => onChangeRecordField(index, e.target, true)}
        bkValue={value}
      >
        {lotteryStatus.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  };

  // 未受講・受講中・受講済み
  const returnAsField = (index, value) => {
    const { ref, ...rest } = register("attendance_status_" + index);

    return (
      <select
        ref={(e) => {
          recordAsRefs.current[index].current = e;
          ref(e);
        }}
        {...rest}
        onChange={(e) => onChangeRecordField(index, e.target)}
        bkValue={value}
      >
        {attendanceStatus.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  };

  // 取得単位数
  const returnAuField = (index, value) => {
    const { ref, ...rest } = register("acquisition_unit_" + index);

    return (
      <input
        className={"input " + styles.movetable__acquisition_unit_input}
        type="number"
        min="0"
        max="99999"
        ref={(e) => {
          recordAuRefs.current[index].current = e;
          ref(e);
        }}
        {...rest}
        onChange={(e) => onChangeRecordField(index, e.target)}
        bkValue={value ? value : ""}
      />
    );
  };

  // 出席情報更新フラグ値
  const returnUaField = (index) => {
    const { ref, ...rest } = register("is_update_attendance_" + index);

    return (
      <input
        className="input"
        type="text"
        defaultValue={0}
        ref={(e) => {
          recordUaRefs.current[index].current = e;
          ref(e);
        }}
        {...rest}
      />
    );
  };

  // 出席・欠席ドロップダウンリスト
  const returnAttendanceSelect = (index, num, value) => {
    const { ref, ...rest } = register("attendance_" + index + "_" + (num + 1));

    return (
      <select
        name={"attendance_" + index + "_" + (num + 1)}
        ref={(e) => {
          recordAdRefs.current[index][num].current = e;
          ref(e);
        }}
        {...rest}
        onChange={(e) => {
          onChangeRecordField(index, e.target);
          // 全15個の出席情報からvalue=1：出席の個数をカウント
          let attendanceCount = 0;
          for (let i = 0; i < 15; i++) {
            const attendanceElement = recordAdRefs.current[index][i]?.current;
            if (attendanceElement && attendanceElement.value === "1") {
              attendanceCount++;
            }
          }
          // カウントした個数を取得単位数に設定
          setValue("acquisition_unit_" + index, String(attendanceCount));
          // 取得単位数フィールドの背景色も変更
          const auElement = recordAuRefs.current[index].current;
          if (auElement && !auElement.className.includes(styles.is_change)) {
            auElement.className = auElement.className + " " + styles.is_change;
          }
        }}
        bkvalue={value}
      >
        <option value="0">▼選択</option>
        {attendance.map((option) => (
          <option value={String(option.value)}>{option.label}</option>
        ))}
      </select>
    );
  };

  // 一覧データセット
  const tableDataSet = (tableData) => {
    // テーブルレイアウト作成よりも早くデータセットが動いてしまうことを防ぐ為にsetTimeout
    setTimeout(() => {
      tableData.map((d, i) => {
        // 学生番号
        setValue("student_id_" + i, d.student_id);
        // 当選状況
        setValue("lottery_status_" + i, d.lottery_status);
        // 未受講・受講中・受講済み
        setValue("attendance_status_" + i, d.attendance_status);
        // 取得単位数
        setValue("acquisition_unit_" + i, d.acquisition_unit);
        // 出席情報
        {
          Array.from({ length: 15 }).map((_, num) =>
            setValue(
              "attendance_" + i + "_" + (num + 1),
              d["attendance" + (num + 1)]
            )
          );
        }
        // 更新日時
        setValue("updated_at_" + i, d.updated_at);
      });
    }, 500);
  };

  // 固定部分
  const fixTable = (sortedData) => {
    const tableMeata = [
      { key: "login_id", label: "学生番号(8桁)" },
      { key: "name_link", label: "氏名" },
    ];
    const fixSortedData = [];
    sortedData.forEach(function (sData) {
      fixSortedData.push({
        login_id: sData.login_id,
        student_id: sData.student_id,
        name_link: sData.name_link,
      });
    });
    return (
      <div className={styles.fixtable}>
        <table class={styles.responsivetable}>
          <thead>
            <tr className={styles.fixtable__tr}>
              <th className={styles.fixtable__ckbox}>
                <input
                  type="checkbox"
                  value="1"
                  ref={headerCkRef}
                  onChange={onChangeCk}
                />
              </th>
              {tableMeata.map((field) => (
                <th
                  onClick={() => handleTableHeaderClick(field.key)}
                  className={styles["fixtable__" + field.key]}
                >
                  {field.label}{" "}
                  {field.key === sortBy ? (sortAscending ? "▲" : "▼") : ""}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {fixSortedData.map((rData, index) => (
              <tr className={styles.fixtable__tr}>
                <td>
                  {returnCkField(index)}
                  <div hidden>
                    <input
                      className="input"
                      type="text"
                      name={"student_id_" + index}
                      {...register("student_id_" + index, {})}
                    ></input>
                  </div>
                </td>
                <td className={styles.fixtable__login_id}>{rData.login_id}</td>
                <td className={styles.fixtable__name_link}>
                  {rData.name_link}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // スクロール移動部分
  const moveTable = (sortedData) => {
    var tableMeata = [];
    if (authority == AUTH_SHIBUYA) {
      tableMeata = [
        { key: "name_kana", label: "フリガナ" },
        { key: "lottery_status", label: "当選状況" },
        { key: "how_apply", label: "申込方法" },
        { key: "attendance_status", label: "未受講・受講中・受講済み" },
        { key: "attendance_updated_date", label: "出欠情報更新日時" },
        { key: "acquisition_unit", label: "取得単位数" },
      ];
    } else {
      tableMeata = [{ key: "name_kana", label: "フリガナ" }];
    }
    var attendanceMeata = [
      { key: "attendance1", label: "1回目" },
      { key: "attendance2", label: "2回目" },
      { key: "attendance3", label: "3回目" },
      { key: "attendance4", label: "4回目" },
      { key: "attendance5", label: "5回目" },
      { key: "attendance6", label: "6回目" },
      { key: "attendance7", label: "7回目" },
      { key: "attendance8", label: "8回目" },
      { key: "attendance9", label: "9回目" },
      { key: "attendance10", label: "10回目" },
      { key: "attendance11", label: "11回目" },
      { key: "attendance12", label: "12回目" },
      { key: "attendance13", label: "13回目" },
      { key: "attendance14", label: "14回目" },
      { key: "attendance15", label: "15回目" },
    ];

    var moveSortedData = [];
    if (authority == AUTH_SHIBUYA) {
      sortedData.forEach(function (sData) {
        moveSortedData.push({
          name_kana: sData.name_kana,
          lottery_status: sData.lottery_status,
          how_apply: sData.how_apply,
          attendance_status: sData.attendance_status,
          attendance_updated_date: sData.attendance_updated_date,
          acquisition_unit: sData.acquisition_unit,
          attendance1: sData.attendance1,
          attendance2: sData.attendance2,
          attendance3: sData.attendance3,
          attendance4: sData.attendance4,
          attendance5: sData.attendance5,
          attendance6: sData.attendance6,
          attendance7: sData.attendance7,
          attendance8: sData.attendance8,
          attendance9: sData.attendance9,
          attendance10: sData.attendance10,
          attendance11: sData.attendance11,
          attendance12: sData.attendance12,
          attendance13: sData.attendance13,
          attendance14: sData.attendance14,
          attendance15: sData.attendance15,
        });
      });
    } else {
      sortedData.forEach(function (sData) {
        moveSortedData.push({
          name_kana: sData.name_kana,
          attendance1: sData.attendance1,
          attendance2: sData.attendance2,
          attendance3: sData.attendance3,
          attendance4: sData.attendance4,
          attendance5: sData.attendance5,
          attendance6: sData.attendance6,
          attendance7: sData.attendance7,
          attendance8: sData.attendance8,
          attendance9: sData.attendance9,
          attendance10: sData.attendance10,
          attendance11: sData.attendance11,
          attendance12: sData.attendance12,
          attendance13: sData.attendance13,
          attendance14: sData.attendance14,
          attendance15: sData.attendance15,
        });
      });
    }
    return (
      <div className={styles.movetable}>
        <table class={styles.responsivetable}>
          <thead>
            <tr className={styles.movetable__tr}>
              {tableMeata.map((field) => (
                <th
                  onClick={() => handleTableHeaderClick(field.key)}
                  className={styles["movetable__" + field.key]}
                >
                  {field.label}{" "}
                  {field.key === sortBy ? (sortAscending ? "▲" : "▼") : ""}
                </th>
              ))}
              {attendanceMeata.map((field) => (
                <th
                  onClick={() => handleTableHeaderClick(field.key)}
                  className={styles.movetable__attendance}
                >
                  {field.label}{" "}
                  {field.key === sortBy ? (sortAscending ? "▲" : "▼") : ""}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {moveSortedData.map((rData, index) => (
              <tr className={styles.movetable__tr}>
                <td className={styles.movetable__name_kana}>
                  {rData.name_kana}
                </td>
                {authority == AUTH_SHIBUYA ? (
                  <td className={styles.movetable__lottery_status}>
                    {returnLsField(index, rData.lottery_status)}
                  </td>
                ) : (
                  <></>
                )}
                {authority == AUTH_SHIBUYA ? (
                  <td className={styles.movetable__how_apply}>
                    {rData.how_apply}
                  </td>
                ) : (
                  <></>
                )}
                {authority == AUTH_SHIBUYA ? (
                  <td className={styles.movetable__attendance_status}>
                    {returnAsField(index, rData.attendance_status)}
                  </td>
                ) : (
                  <></>
                )}
                {authority == AUTH_SHIBUYA ? (
                  <td className={styles.movetable__attendance_updated_date}>
                    {rData.attendance_updated_date}
                  </td>
                ) : (
                  <></>
                )}
                {authority == AUTH_SHIBUYA ? (
                  <td className={styles.movetable__acquisition_unit}>
                    {returnAuField(index, rData.acquisition_unit)}
                  </td>
                ) : (
                  <></>
                )}
                <div hidden>{returnUaField(index)}</div>
                {Array.from({ length: 15 }).map((_, i) => (
                  <td className={styles.movetable__attendance}>
                    {returnAttendanceSelect(
                      index,
                      i,
                      rData["attendance" + (i + 1)]
                    )}
                  </td>
                ))}
                <div hidden>
                  <TextField
                    errors={errors}
                    register={register}
                    validation={{}}
                    label=""
                    name={"updated_at_" + index}
                    isStatic={true}
                  />
                </div>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className={commonStyles.datatable}>
      <RecordNum />
      <select
        name="limit"
        value={limit}
        onChange={(e) => handleLimitChange(e.target.value)}
        className={commonStyles.datatable__dispnum}
      >
        {PAGE_Limit.map((el) => (
          <option value={el.value}>{el.label}</option>
        ))}
      </select>
      <Pagination />
      <div class={styles.tablearea}>
        {fixTable(sortedData)}
        {moveTable(sortedData)}
      </div>
      <Pagination />
      {tableDataSet(sortedData)}
    </div>
  );
};

export default CourseApplicantDataTable;
